import React, {useEffect, useState} from "react";
import {Text} from "@gs-ux-uitoolkit-react/text";
import {Button} from "@gs-ux-uitoolkit-react/button";
import {LegacyIcon} from '@gs-ux-uitoolkit-react/icon-font';
import {SignInPageLayout} from "./components/SignInPageLayout";

export function SignedOut() {

    const [countDown, setCountDown] = useState(30);
    const domain = window.location.hostname;
    const isAdvisorSite = domain.includes('advisorsolutions');

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCountDown(prev => Math.max(prev - 1, 0));
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    const backToSignIn = () => {
        return isAdvisorSite ? window.location.href = '/app' : window.location.href = '/client-app';
    }

    useEffect(() => {
        if (countDown === 0) {
            backToSignIn();
        }
    }, [countDown]);

    return (
        <SignInPageLayout>
            <div className="flex flex-col items-start space-y-6 w-[454px] max-w-full">
                <div className="flex flex-row space-x-2 items-center">
                    <LegacyIcon className="text-gray-90" size="lg" name="warning" type="outlined"></LegacyIcon>
                    <Text typography="textSubtitle02Medium" color="colorTextNeutralBold">
                        You are signed out of your session
                    </Text>
                </div>
                <Text typography="textBody01Medium" color="colorTextNeutralBold">
                    If you did not request this, we may have signed you out automatically
                    once you've been idle for more than 15 or 60 minutes (depending on the
                    idle timeout value you've set in your user settings),
                    or signed in from more than 3 devices.
                </Text>
                <Button
                    className="w-full rounded"
                    size="lg"
                    emphasis="regular"
                    onClick={backToSignIn} 
                    appearance="neutral"
                >
                    Back to Sign In
                </Button>
                <Text typography="textBody01Medium" color="colorTextNeutralBold">
                    You will be automatically redirected in {countDown} seconds to the Sign In page.
                </Text>
            </div>
        </SignInPageLayout>
    );

}